import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from './common/services/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { UserDataService } from '@sb-tools/typescript/services/user-data.service';
import { OutlookUserService } from '@form-field-module/common/services/outlook-user.service';
import { FormCommonDataService } from '@form-field-module/common/services/form-common-data.service';
import { LocalizationLanguage } from '@sb-tools/typescript/enums/localization-language.enum';
import { LoaderComponent } from '@sb-tools/typescript/components/loader/loader.component';
import { FormComponent } from './form/form.component';
import { LoginPageComponent } from './login-page/login-page.component';
import { SimpleNotificationsModule } from 'angular2-notifications';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [LoaderComponent, FormComponent, LoginPageComponent, SimpleNotificationsModule],
})
export class AppComponent implements OnInit, OnDestroy {
    isLoading = true;

    private unsubscriber = new Subject<void>();

    constructor(
        public authenticationService: AuthenticationService,
        public userDataService: UserDataService,
        public outlookUserService: OutlookUserService,
        private translateService: TranslateService,
        private formCommonDataService: FormCommonDataService,
        private zone: NgZone,
    ) {}

    ngOnInit(): void {
        Office.onReady(() => {
            let language;
            switch (Office.context.displayLanguage) {
                case 'nb-NO': {
                    this.translateService.use('nb');
                    language = LocalizationLanguage.norwegian;
                    break;
                }
                case 'sv-SE': {
                    this.translateService.use('sv_SE');
                    language = LocalizationLanguage.swedish;
                    break;
                }
                default:
                    language = LocalizationLanguage.english;
                    this.translateService.use(undefined);
            }
            this.formCommonDataService.language = language;
        });

        if (this.authenticationService.isLoggedIn()) {
            this.loadUserCommunities();
        } else {
            this.isLoading = false;
        }
    }

    loadUserCommunities(): void {
        this.userDataService
            .getCommunities()
            .pipe(
                takeUntil(this.unsubscriber),
                finalize(() => {
                    // zone.run is needed here because code is run out of angular zone (in office js)
                    this.zone.run(() => {
                        this.isLoading = false;
                    });
                }),
            )
            .subscribe((communities) => {
                this.outlookUserService.communities = communities;
                // zone.run is needed here because code is run out of angular zone (in office js)
                this.zone.run(() => {
                    this.outlookUserService.isLoggedIn = true;
                });
            });
    }

    ngOnDestroy(): void {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
